export class NotSavedYetError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = "NotSavedYetError";
  }
}

export class OfflineException extends Error {
  constructor() {
    super();
    this.name = "OfflineException";
  }
}

type AuthenticationFailedReason =
  | "invalidCredentials"
  | "failedToFinalize"
  | "genericError";

export class AuthenticationFailedException extends Error {
  reason: AuthenticationFailedReason;

  constructor(reason: AuthenticationFailedReason, message: string) {
    super(message);
    this.reason = reason;
  }
}
